import React from "react";
import { FaExternalLinkAlt, FaTrophy } from "react-icons/fa";

import ModalShell from "./ModalShell";

function ResultLine({ label, value }) {
  if (!value) return null;

  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
        {label}
      </p>

      <p className="mt-2 text-sm font-bold leading-6 text-slate-800 dark:text-white">
        {value}
      </p>
    </div>
  );
}

function EventResultsModal({ event, onClose }) {
  if (!event) return null;

  const result = event.AdherentEvent || {};

  return (
    <ModalShell
      title="Résultats de l’événement"
      eyebrow={event.titre}
      onClose={onClose}
      maxWidth="max-w-3xl"
    >
      <div className="mb-5 flex items-start gap-4 rounded-[1.5rem] border border-amber-200 bg-amber-50 p-4 dark:border-amber-400/20 dark:bg-amber-500/10">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-400 text-slate-950">
          <FaTrophy />
        </div>

        <div>
          <h3 className="font-titre text-xl font-bold text-slate-950 dark:text-white">
            {event.titre || "Événement"}
          </h3>

          <p className="mt-1 text-sm font-medium leading-6 text-slate-600 dark:text-white/55">
            Retrouvez ici les informations de résultat rattachées à ce judoka
            pour cet événement.
          </p>
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <ResultLine label="Classement" value={result.classement} />
        <ResultLine label="Résultat" value={result.resultats} />
        <ResultLine label="Observations" value={result.observations} />
        <ResultLine label="Statut" value={result.status} />
      </div>

      {(result.podium_url || result.tableau_url) && (
        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          {result.podium_url && (
            <a
              href={result.podium_url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 dark:bg-white dark:text-slate-950"
            >
              Voir le podium
              <FaExternalLinkAlt className="text-xs" />
            </a>
          )}

          {result.tableau_url && (
            <a
              href={result.tableau_url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 dark:bg-white dark:text-slate-950"
            >
              Voir le tableau
              <FaExternalLinkAlt className="text-xs" />
            </a>
          )}
        </div>
      )}
    </ModalShell>
  );
}

export default EventResultsModal;